import React, {
  useContext,
  useEffect,
  useState,
} from 'react';
import { AppContext } from '../app/AppProvider.component';
import { ChatReferenceDto, } from '../../apis/nhe-ai-chat-service/nhe-ai-chat-service.dtos';
import { putReferenceVideoDataAction } from '../app/app-state-actions.utilities';
import {
  getParsedContentPropsVideo,
  getVideoDurationDisplay
} from '../../pages/ai-chat/ai-chat.utilities';
import { FlexLayout } from '../flex/FlexLayout.component';
import { FlexItem } from '../flex/FlexItem.component';
import { FlexLayoutModifier } from '../flex/flex.constants';

export type VideoThumbnailProps = {
  reference: ChatReferenceDto;
  onUpdateChatEntryReference: (chatReference: ChatReferenceDto) => void;
}

export const VideoThumbnailComponent = (props: VideoThumbnailProps): JSX.Element => {

  const {
    appState,
    setAppState,
    appStateRef
  } = useContext(AppContext);

  const [hasCalledApi, setHasCalledApi] = useState(false);

  useEffect(() => {
    // Skip if we've already called the API for this reference
    if (hasCalledApi) {
      return;
    }

    const contentProps = getParsedContentPropsVideo(props.reference);
    if (
      contentProps?.sections_video_muxThumbSmall
      || contentProps?.sections_video_muxThumb
      || contentProps?.metadata_videoObjectStructuredData
    ) {
      return;
    }

    setHasCalledApi(true);

    putReferenceVideoDataAction({
      appState,
      setAppState,
      appStateRef,
      referenceId: props.reference.id
    }).then((response) => {
      props.onUpdateChatEntryReference(response);
    });
  }, [props.reference, hasCalledApi]);

  const contentProps = getParsedContentPropsVideo(props.reference);

  if (!contentProps?.sections_video_muxThumbSmall) {
    return <div className="u-els-padding">{props.reference.title}</div>;
  }

  const duration = getVideoDurationDisplay(props.reference)

  const src = `https://d16qt3wv6xm098.cloudfront.net/${contentProps?.sections_video_muxThumbSmall}`
  return (
    <div className="c-els-video-thumbnail" title={props.reference.title}>
      <FlexLayout modifiers={[FlexLayoutModifier.LEFT]}>
        <FlexItem>
          <div className="c-els-video-thumbnail__wrapper">
            <img
              src={src}
              alt={props.reference.title}
              className="c-els-video-thumbnail__image"
            />
            <div className="c-els-video-thumbnail__overlay">
              <div className="c-els-video-thumbnail__play-arrow">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {/*eslint-disable-next-line max-len*/}
                  <path d="M8 5.5C8 4.67157 8.89543 4.13002 9.6 4.6L17.4 9.6C18.1046 10.07 18.1046 11.13 17.4 11.6L9.6 16.6C8.89543 17.07 8 16.5284 8 15.7V5.5Z" strokeLinejoin="round" />
                </svg>
              </div>
            </div>
            {duration && (
              <div className="c-els-video-thumbnail__duration">{duration}</div>
            )}
          </div>
        </FlexItem>
      </FlexLayout>
      <div className="c-els-video-thumbnail__title">{props.reference.title}</div>
    </div>
  );
};

const VideoThumbnail = VideoThumbnailComponent;
export default VideoThumbnail;
